var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKitchen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8C8.71667 8 8.47933 7.904 8.288 7.712C8.09667 7.52 8.00067 7.28267 8 7V6C8 5.71667 8.096 5.47933 8.288 5.288C8.48 5.09667 8.71733 5.00067 9 5C9.28267 4.99933 9.52033 5.09533 9.713 5.288C9.90567 5.48067 10.0013 5.718 10 6V7C10 7.28333 9.904 7.521 9.712 7.713C9.52 7.905 9.28267 8.00067 9 8ZM9 17C8.71667 17 8.47933 16.904 8.288 16.712C8.09667 16.52 8.00067 16.2827 8 16V13C8 12.7167 8.096 12.4793 8.288 12.288C8.48 12.0967 8.71733 12.0007 9 12C9.28267 11.9993 9.52033 12.0953 9.713 12.288C9.90567 12.4807 10.0013 12.718 10 13V16C10 16.2833 9.904 16.521 9.712 16.713C9.52 16.905 9.28267 17.0007 9 17ZM6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.19667 21.0217 4.00067 20.5507 4 20V4C4 3.45 4.196 2.97933 4.588 2.588C4.98 2.19667 5.45067 2.00067 6 2H18C18.55 2 19.021 2.196 19.413 2.588C19.805 2.98 20.0007 3.45067 20 4V20C20 20.55 19.8043 21.021 19.413 21.413C19.0217 21.805 18.5507 22.0007 18 22H6ZM6 20H18V11H6V20ZM6 9H18V4H6V9Z",
    fill: "#292929"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.515337c9d6806f8a70abcd6fffcb13b3.svg";
export { ForwardRef as ReactComponent };